import { render, staticRenderFns } from "./MaterialTestimonyOLD.vue?vue&type=template&id=3eb8aa0a"
import script from "./MaterialTestimonyOLD.vue?vue&type=script&lang=js"
export * from "./MaterialTestimonyOLD.vue?vue&type=script&lang=js"
import style0 from "./MaterialTestimonyOLD.vue?vue&type=style&index=0&id=3eb8aa0a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports